'use client';

import type { DefaultStateProps } from './types';
import SearchSidebar from './Sidebar/SearchSidebar';
import ProductSection from './ProductGrid/ProductSection';
import PromoBanners from './PromoBanners';
import { useClientConfig } from '@/lib/clients/ClientContext';

export default function DefaultState({
  recentSearches,
  topSearches,
  popularProducts,
  onSearchClick,
  onRemoveRecent,
  externalPrices,
  externalPricesLoading,
  viewMode,
  onViewModeChange,
}: DefaultStateProps) {
  const clientConfig = useClientConfig();

  return (
    <div className="flex items-start flex-1 self-stretch min-h-0 border-t border-[#D8D8D8]">
      {/* Sidebar - hidden on mobile */}
      <div className="hidden md:block flex-shrink-0 self-stretch">
        <SearchSidebar
          recentSearches={recentSearches}
          topSearches={topSearches}
          onSearchClick={onSearchClick}
          onRemoveRecent={onRemoveRecent}
        />
      </div>

      {/* Main product area */}
      <div className="flex flex-col items-start flex-1 flex-shrink-0 min-w-0 self-stretch overflow-y-auto">
        {/* Promo banners (configurable per client) — render above the products */}
        <PromoBanners />
        {popularProducts.length > 0 && (
          <ProductSection
            title={clientConfig.ui.strings.popularProducts}
            products={popularProducts}
            viewMode={viewMode}
            onViewModeChange={onViewModeChange}
            fluidGrid
            source="browse"
            // B2B: without these the entry screen shows indexed RRP instead of
            // the customer's own price (fixed 2026-07-27).
            externalPrices={externalPrices}
            externalPricesLoading={externalPricesLoading}
          />
        )}
      </div>
    </div>
  );
}
